import { createFileRoute } from '@tanstack/react-router'
import LoadingAlt from '@/components/LoadingAlt'

function LoadingPage() {
  return <LoadingAlt />
}

export const Route = createFileRoute('/loading')({
  component: LoadingPage,
})
